import { Link } from "react-router-dom";
import ProfileImage from "../../components/ProfileImage";

export default function Friends({ friends }) {
  return (
    <div className="profile_card">
      <div className="profile_card_header">
        Friends
        <div className="profile_header_link">See all friends</div>
      </div>
      {friends && (
        <div className="profile_card_count">
          {friends.length === 0
            ? ""
            : friends.length === 1
            ? "1 Friend"
            : `${friends.length} Friends`}
        </div>
      )}
      <div className="profile_card_grid">
        {friends &&
          friends.slice(0, 9).map((friend) => (
            <Link
              key={friend._id}
              to={`/profile/${friend.username || friend._id}`}
              className="profile_photo_card"
            >
              <ProfileImage 
                src={friend.picture} 
                alt={friend.name || `${friend.first_name || ""} ${friend.last_name || ""}`.trim() || "Friend"}
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '15px' }}
                placeholderText="No image"
              />
              <span>
                {friend.name || `${friend.first_name || ""} ${friend.last_name || ""}`.trim() || "Unknown"}
              </span>
            </Link>
          ))}
      </div>
    </div>
  );
}
